import React from 'react';

interface ScreenHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  kicker?: React.ReactNode;
  media?: React.ReactNode;
  align?: 'start' | 'center';
  className?: string;
  titleClassName?: string;
  children?: React.ReactNode;
}

export function ScreenHeader({
  title,
  subtitle,
  kicker,
  media,
  align = 'start',
  className = '',
  titleClassName = '',
  children,
}: ScreenHeaderProps) {
  const alignClassName = align === 'center' ? 'text-center items-center' : 'text-left items-start';
  const alignModifierClassName = align === 'center' ? 'screen-header--center' : 'screen-header--start';

  return (
    <header className={`screen-header ${alignModifierClassName} flex flex-col ${alignClassName} ${className}`.trim()}>
      {kicker && (
        <p className="screen-header__kicker text-[10px] uppercase tracking-[0.22em] text-(--color-text)/60">
          {kicker}
        </p>
      )}
      {media && <div className="screen-header__media">{media}</div>}
      <h1 className={`screen-header__title text-2xl font-bold ${titleClassName}`.trim()}>{title}</h1>
      {subtitle && (
        <p className="screen-header__subtitle mt-1 text-sm text-(--color-text)/70">
          {subtitle}
        </p>
      )}
      {children && <div className="screen-header__body">{children}</div>}
    </header>
  );
}
